import { Status } from './enums/status.enum';

export function isNonActiveUser(status: string | null) {
  return (
    (+status! as Status) === Status.New ||
    (+status! as Status) === Status.Invited
  );
}
